import { render, staticRenderFns } from "./UploadOption.vue?vue&type=template&id=1a9d1255&scoped=true"
import script from "./UploadOption.vue?vue&type=script&lang=js"
export * from "./UploadOption.vue?vue&type=script&lang=js"
import style0 from "./UploadOption.vue?vue&type=style&index=0&id=1a9d1255&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9d1255",
  null
  
)

export default component.exports